import { useCallback } from 'react';

import { useToggleRefinement } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';

import { INSTANT_SEARCH_VICTORY_FILTER } from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<
	undefined,
	{
		filterByVictories: () => void;
	}
>;

export function useFilterByVictories(): Result {
	const { refine } = useToggleRefinement({
		attribute: INSTANT_SEARCH_VICTORY_FILTER,
		on: 'victory',
		off: undefined,
	});
	const track = useTracking();

	return {
		actions: {
			filterByVictories: useCallback(() => {
				void track('search', { q: '', context: 'landing_victories_button' });
				refine({ isRefined: false });
			}, [refine, track]),
		},
	};
}
